module.exports = __webpack_public_path__ + "media/images/hero_images/security-1500-4ef15cf0028703d1eccdbf90adad8fc2.jpg";